/** Claims whose values are NumericDate (seconds since epoch). */
export const TIMESTAMP_CLAIMS = new Set(['exp', 'iat', 'nbf']);

/** Well-known JWT claims and header parameters (RFC 7519 / RFC 7515). */
export const REGISTERED_CLAIMS: Record<string, string> = {
  // RFC 7519 registered claims
  iss: 'Issuer',
  sub: 'Subject',
  aud: 'Audience',
  exp: 'Expiration time',
  nbf: 'Not before',
  iat: 'Issued at',
  jti: 'JWT ID',

  // RFC 7515 header parameters
  alg: 'Algorithm',
  typ: 'Token type',
  kid: 'Key ID',
  cty: 'Content type',
};

/** Human-readable label: registered name, or title case from the key (e.g. email → Email). */
export function formatClaimTitle(key: string): string {
  const registered = REGISTERED_CLAIMS[key];
  if (registered !== undefined) {
    return registered;
  }

  const segments = key.split('_').filter((segment) => segment.length > 0);
  if (segments.length === 0) {
    return key;
  }

  return segments
    .map((segment) => {
      return segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase();
    })
    .join(' ');
}
